import script from "./Pla08EditConferirPage.vue?vue&type=script&setup=true&lang=js"
export * from "./Pla08EditConferirPage.vue?vue&type=script&setup=true&lang=js"

import "./Pla08EditConferirPage.vue?vue&type=style&index=0&id=1f98e366&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f98e366"]])

export default __exports__